<ngx-spinner
  bdColor="rgba(51,51,51,0.9)"
  size="large"
  color="#040f768c"
  type="square-jelly-box">
  <p style="font-size: 29px; color: white;margin: 10px;">Procesando ...</p>
</ngx-spinner>
<router-outlet></router-outlet>